import { Route } from "react-router-dom";

export const renderRoutes = (routes, store = null) =>
  routes.map(route => {
    return (
      <Route
        key={route.path}
        path={route.path}
        hydrateFallbackElement={<>Loading...</>}
        lazy={async () => {
          const { default: Component } = await route.component();

          return {
            element: <Component tag={route.tag} />,
          };
        }}
      />
    );
  });
